import { Form, SubmitFormButton, TextField, useFormField } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { Button } from '@calendly/ui/components/button';
import { CloseCircleIcon } from '@calendly/ui/components/icons';
import { Body, Footer, Popup } from '@calendly/ui/components/popup';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useHistory } from 'react-router-dom';
import { Layout, LayoutItem } from 'components/layout';
import { useGetAvailabilitySchedulesQuery, useUpdateAvailabilityScheduleMutation } from '../../../api';
import { pushHrefPreservingSearchExcept } from '../../schedules_routes_context';
import { getValidationSchema } from '../name_validation_schema';
const clearButtonCss = "c1jchael";
const ClearButton = forwardRef((props, ref) => {
  const tabIndex = -1;
  return <BareButton ref={ref} {...props} tabIndex={tabIndex} aria-hidden data-testid="clear-button" className={classNames(clearButtonCss, props.className)}>
      <CloseCircleIcon />
    </BareButton>;
});
const textFieldProps = {
  style: {
    padding: '10px 40px 10px 16px'
  }
};
const TextFieldWithClearButton = props => {
  const [{
    value
  }, _, {
    setValue,
    setTouched
  }] = useFormField({
    name: 'name'
  });
  const handleClear = () => {
    setValue('');
    setTouched(true);
  };
  return <LayoutItem relative>
      <TextField {...props} {...textFieldProps} />
      {value && <ClearButton onClick={handleClear} />}
    </LayoutItem>;
};
const FormLayout = props => <Layout direction="column" gap="24" {...props} />;
export const RenameSchedulePopup = ({
  selectedScheduleId
}) => {
  const history = useHistory();
  const {
    data: allSchedules
  } = useGetAvailabilitySchedulesQuery();
  const [updateAvailabilitySchedule] = useUpdateAvailabilityScheduleMutation({
    fixedCacheKey: `update-availability-schedule-${selectedScheduleId}`
  });
  const selectedSchedule = allSchedules.find(({
    id: scheduleId
  }) => scheduleId === selectedScheduleId);
  const handleClose = () => pushHrefPreservingSearchExcept(history, ['rename']);
  const handleSubmit = ({
    name
  }) => updateAvailabilitySchedule({
    updatedSchedule: {
      id: selectedScheduleId,
      name
    },
    onSuccess: handleClose
  });
  const initialValues = {
    name: selectedSchedule.name
  };
  return <Popup withCloseButton title={I18n.t('publisher.availability.schedules.rename_popup.title')} onClose={handleClose}>
      <Form initialValues={initialValues} validationSchema={getValidationSchema()} onSubmit={handleSubmit}>
        <FormLayout>
          <Body>
            <TextFieldWithClearButton placeholder={I18n.t('publisher.availability.schedules.text_field_popup.placeholder')} label={I18n.t('publisher.availability.schedules.schedule_name')} name="name" data-1p-ignore="true" data-lpignore="true" />
          </Body>
          <Footer>
            <Button decoration="secondary-outline" onClick={handleClose}>
              {I18n.t('publisher.action.cancel')}
            </Button>
            <SubmitFormButton>
              {I18n.t('publisher.action.save')}
            </SubmitFormButton>
          </Footer>
        </FormLayout>
      </Form>
    </Popup>;
};

require("./rename_schedule_popup.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./rename_schedule_popup.js");